import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { VehicleCalendar } from "@/common/components/Calendar/Entity/VehicleCalendar";
import { VehicleDto } from "@/core/api/generated/v1";

interface Props {
  vehicle: VehicleDto;
}

export default function CalendarTabContent({ vehicle }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock sx={{ pt: 0 }}>
        <VehicleCalendar vehicle={vehicle} />
      </ViewContentBlock>
    </PageTabContent>
  );
}
